import { render, staticRenderFns } from "./DeleteDialog.vue?vue&type=template&id=056f0760&"
import script from "./DeleteDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('056f0760')) {
      api.createRecord('056f0760', component.options)
    } else {
      api.reload('056f0760', component.options)
    }
    module.hot.accept("./DeleteDialog.vue?vue&type=template&id=056f0760&", function () {
      api.rerender('056f0760', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "backoffice/themes/base/src/components/FormModal/DeleteDialog.vue"
export default component.exports